import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route 
} from "react-router-dom";
import { Link } from "react-router-dom";

import Navigation from "./Components/Navigation";
import Home from "./Pages/Home";
import Books from "./Pages/Books";
import About from "./Pages/About";
import Blog from "./Pages/Blog";
import Contact from "./Pages/Contact";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import './css/App.css';

import fbIcon from "./images/social-images/facebook1.png";
import goodreadsIcon from "./images/social-images/goodreads.png";
import blueSkyIcon from "./images/social-images/bluesky.png";
import bookbubIcon from "./images/social-images/bookbub.png";

//const pages = ["Home", "Books", "About", "Blog", "Contact"];
const pages = ["Home", "Books", "About", "Contact"];


export default class App extends React.Component {

  render () {
   
   return ( 
    <Router>
    <div className="App">

        <div class="content-header-wrapper">
          <Navigation pages={pages} />
          <div class="page-content">

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/books" element={<Books />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>


          <div class="footer">
            <div class="footer-content social">
              <a href="https://www.facebook.com/james.hillebrecht"><img src={fbIcon} width="25" height="25"></img></a>
              <a href="https://bsky.app/profile/jameshillebrecht.bsky.social"><img src={blueSkyIcon} width="25" height="25"></img></a>
              <a href="https://www.goodreads.com/author/show/6445020.James_A_Hillebrecht"><img src={goodreadsIcon} width="25" height="25"></img></a>
              <a href="https://www.bookbub.com/authors/james-hillebrecht"><img src={bookbubIcon} width="25" height="25"></img></a>
            </div>
            <div class="footer-content copyright">&#169; James A. Hillebrecht. All Rights Reserved</div>
            <div class="footer-content privacy">
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </div> 
        </div>
      </div>
    </div>
    </Router>
  )}
} 

